import React from 'react';
import { useState } from 'react';
import ShoppingListElement from './ShoppingListElement/ShoppingListElement'
import { useData } from "../../DataContext/DataProvider"

/**
 * Searchable list of shopping list items
 * params: 
 * shoppingArray [{
     *  Item_ID: int
     * Item_Name: string
     * Item_Quantity: int
     * Item_Recipe_Plan: (Plan_ID) can be null
     * Plan_Date: int, can be null
     * Recipe_Name: string, can be null
     * Item_Recipe_Plan_Ingredient: (Recipe_Ingredient_ID) can be null
 * },...]
 * searchChangeHandler function input:string  return:null 
 * returns
 */
function ShoppingList() {

    const [searchInput, setSearchInput] = useState("")
    const dataContext = useData();

    const shoppingArray = dataContext.shoppingListData.shoppingList?.filter((listItem) => {
        return listItem.Item_Name.toLocaleUpperCase().includes(searchInput.toLocaleUpperCase())//make search case insensitive. *locale* upper case prevents weird stuff like turkish I, apparently
    });

    const onSearchChange = (e) => {
        e.preventDefault()
        setSearchInput(e.target.value)
    }

    return (
        <div className={"shopping-list-container" + (dataContext.shoppingListData.serverAccess === 0 ? " loading" : "")}>
            <label className="hoverable-element"> Search: 
                <input onChange={ onSearchChange } placeholder="...Search"/>
            </label>
            {shoppingArray.length === 0 ? "Nothing in your list" : null }
            <ul className="shopping-list-list-container rows three">
                {
                    shoppingArray.map((element, index) => {
                        return (<ShoppingListElement key={index} initialData={element}/>)
                    })
                }
            </ul>
        </div>
    )
}

export default ShoppingList